import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

export default function CartPage() {
  const { items, removeItem, subtotal, count, hasFirearms } = useCart();
  const navigate = useNavigate();
  const TAX_RATE = 8.45;
  const tax = subtotal * (TAX_RATE / 100);
  const total = subtotal + tax;

  if (count === 0) return (
    <div>
      <div className="page-hero"><h1>Your Cart</h1></div>
      <div className="container" style={{ padding: '80px 20px', textAlign: 'center' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>🛒</div>
        <h2 style={{ color: '#1a2744', marginBottom: 8 }}>Your cart is empty</h2>
        <p style={{ color: '#666', marginBottom: 28 }}>Browse our inventory to find something you love.</p>
        <Link to="/shop" className="btn btn-navy btn-lg">Browse Inventory</Link>
      </div>
    </div>
  );

  return (
    <div>
      <div className="page-hero" style={{ padding: '32px 0' }}>
        <h1>Your Cart</h1>
        <p>{count} item{count !== 1 ? 's' : ''}</p>
      </div>

      <div className="container" style={{ padding: '36px 20px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 340px', gap: 32, alignItems: 'start' }}>

          {/* Items */}
          <div>
            {hasFirearms && (
              <div className="alert alert-info" style={{ marginBottom: 20 }}>
                <strong>🔒 Firearm in cart:</strong> You'll be asked to provide your local FFL dealer's information at checkout. The firearm will be shipped to that dealer for your pickup.
              </div>
            )}

            {items.map(item => (
              <div key={item.uuid} style={{ display: 'flex', gap: 16, padding: '20px 0', borderBottom: '1px solid #e8e8e8', alignItems: 'flex-start' }}>
                <div style={{ width: 90, height: 68, borderRadius: 8, overflow: 'hidden', background: '#f4f4f4', flexShrink: 0 }}>
                  <img src={item.primary_image || 'https://via.placeholder.com/90x68?text=Item'} alt={item.title}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
                    <span style={{ fontSize: 11, color: '#9a9a9a', fontWeight: 600, textTransform: 'uppercase' }}>{item.category_name}</span>
                    {item.is_firearm === 1 && <span className="badge badge-firearm" style={{ fontSize: 10 }}>FFL Required</span>}
                  </div>
                  <Link to={`/product/${item.uuid}`} style={{ fontWeight: 700, color: '#1a2744', fontSize: 15 }}>{item.title}</Link>
                  {(item.make || item.model) && (
                    <div style={{ fontSize: 12, color: '#9a9a9a', marginTop: 2 }}>{[item.make, item.model].filter(Boolean).join(' ')}</div>
                  )}
                  <div style={{ marginTop: 4, fontSize: 11, color: '#9a9a9a', textTransform: 'capitalize' }}>Condition: {item.condition}</div>
                </div>
                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                  <div style={{ fontSize: 20, fontWeight: 800, color: '#1a2744', marginBottom: 10 }}>${item.price?.toFixed(2)}</div>
                  <button onClick={() => removeItem(item.uuid)} style={{ fontSize: 12, color: '#c62828', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}>Remove</button>
                </div>
              </div>
            ))}

            <div style={{ marginTop: 20 }}>
              <Link to="/shop" style={{ color: '#c9a227', fontWeight: 600, fontSize: 14 }}>← Continue Shopping</Link>
            </div>
          </div>

          {/* Summary */}
          <div style={{ position: 'sticky', top: 90 }}>
            <div className="card" style={{ padding: 24 }}>
              <h3 style={{ fontWeight: 800, color: '#1a2744', marginBottom: 20, fontSize: 16 }}>Order Summary</h3>
              <div style={{ borderBottom: '1px solid #e8e8e8', paddingBottom: 16, marginBottom: 16 }}>
                {items.map(item => (
                  <div key={item.uuid} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 8, color: '#555' }}>
                    <span style={{ flex: 1, marginRight: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.title}</span>
                    <span style={{ fontWeight: 600, flexShrink: 0 }}>${item.price?.toFixed(2)}</span>
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, marginBottom: 8, color: '#555' }}>
                <span>Subtotal</span><span>${subtotal.toFixed(2)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, marginBottom: 8, color: '#555' }}>
                <span>Tax ({TAX_RATE}%)</span><span>${tax.toFixed(2)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, marginBottom: 8, color: '#9a9a9a' }}>
                <span>Shipping</span><span>Calculated at checkout</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 800, fontSize: 18, color: '#1a2744', borderTop: '2px solid #e8e8e8', paddingTop: 14, marginTop: 8 }}>
                <span>Estimated Total</span><span>${total.toFixed(2)}</span>
              </div>
              <button onClick={() => navigate('/checkout')} className="btn btn-primary btn-lg" style={{ width: '100%', marginTop: 20, justifyContent: 'center' }}>
                Proceed to Checkout →
              </button>
              <div style={{ marginTop: 14, display: 'flex', justifyContent: 'center', gap: 8, flexWrap: 'wrap' }}>
                {['visa','mc','amex','paypal'].map(brand => (
                  <div key={brand} style={{ background: '#f4f4f4', borderRadius: 4, padding: '4px 8px', fontSize: 11, color: '#666', fontWeight: 600, textTransform: 'uppercase' }}>{brand}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
